export const aboutData = {
  hero: {
    title: '关于我们',
    subtitle: '吃瓜网站线路一 · 全网最热吃瓜聚合平台',
    description: '致力于为吃瓜群众提供最新、最快、最全的网红塌房与黑料爆料资讯',
  },
  brandStory: {
    title: '品牌故事',
    subtitle: '从热爱到专业，一群吃瓜爱好者的初心',
    paragraphs: [
      '吃瓜网站线路一诞生于2024年，由一群有着共同爱好的互联网资深吃瓜群众创立。我们深知，在这个信息爆炸的时代，每天都有海量的娱乐八卦和网红新闻涌现，但真正有价值、有深度的爆料内容却常常淹没在信息洪流之中。',
      '我们的使命是打造一个专业、高效、可信赖的吃瓜资讯聚合平台。通过智能算法与人工编辑相结合的方式，对全网吃瓜内容进行实时监控、筛选和整理，确保用户能够在最短的时间内获取到最新鲜、最劲爆的吃瓜内容。',
      '从最初的个人兴趣项目，到如今日均服务超过百万吃瓜用户的专业平台，吃瓜网站线路一始终坚持"真实、快速、全面"的原则。我们建立了严格的内容审核机制和匿名爆料保护制度，在保证内容质量的同时，也保护每一位爆料人的隐私和安全。',
    ],
  },
  reputation: {
    title: '品牌信誉',
    subtitle: '数据见证实力，口碑铸就信任',
    stats: [
      { value: '500万+', label: '日均访问用户' },
      { value: '10万+', label: '累计爆料文章' },
      { value: '99.7%', label: '内容真实率' },
      { value: '50+', label: '合作媒体机构' },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '欢迎各路吃瓜群众和合作方与我们取得联系',
    email: 'contact@chigua.com',
    wechat: 'chigua_51',
    weibo: '@吃瓜网站线路一',
    address: '北京市朝阳区互联网科技园区',
    businessHours: '周一至周日 09:00 - 21:00',
  },
  testimonials: {
    title: '用户口碑',
    subtitle: '来自百万吃瓜用户的真实评价',
    items: [
      {
        id: 1,
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=test-avatar-01&orientation=squarish',
        username: '资深吃瓜人',
        role: '平台忠实用户·3年',
        rating: 5,
        content: '用了这么多吃瓜平台，吃瓜网站线路一真的是最快的！每次网红塌房我都是在这里第一时间看到，比其他平台至少快了半小时。强烈推荐给所有吃瓜爱好者！',
      },
      {
        id: 2,
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=test-avatar-02&orientation=squarish',
        username: '娱乐记者小李',
        role: '娱乐媒体从业者',
        rating: 5,
        content: '作为娱乐记者，吃瓜网站线路一是我的必备工具。51吃瓜网站入口聚合了全网最热的爆料通道，帮我省去了大量搜索时间。内容质量也很高，很少看到假消息。',
      },
      {
        id: 3,
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%2030s%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=test-avatar-03&orientation=squarish',
        username: '新媒体运营老张',
        role: '新媒体公司运营总监',
        rating: 4,
        content: '我们团队每天都在用吃瓜网站线路一追踪热点。每日大赛栏目做得特别好，热门排行实时更新，帮我们抓住了很多流量机会。希望以后能增加更多数据分析功能。',
      },
      {
        id: 4,
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20in%2020s%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=test-avatar-04&orientation=squarish',
        username: '大学生小陈',
        role: '在校大学生·重度吃瓜用户',
        rating: 5,
        content: '自从发现了吃瓜网站线路一，我成了宿舍里的"新闻发言人"！每次班里聊天我都能拿出最新的大瓜，大家都问我消息哪来的。界面也很清爽，刷起来很舒服。',
      },
      {
        id: 5,
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%2040s%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=test-avatar-05&orientation=squarish',
        username: '公关顾问王先生',
        role: '品牌公关顾问',
        rating: 4,
        content: '做品牌公关需要时刻关注舆论动态，吃瓜网站线路一的网红塌房栏目帮我们提前预警了很多潜在风险。信息更新速度很快，内容分类也很清晰，非常实用。',
      },
      {
        id: 6,
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20in%2030s%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=test-avatar-06&orientation=squarish',
        username: '自由撰稿人阿兰',
        role: '自由撰稿人',
        rating: 5,
        content: '吃瓜网站线路一的黑料吃瓜栏目是我写作的重要素材来源。不仅更新快，而且每篇文章都有详细的事件梳理和多方观点，为我节省了大量调研时间。真心推荐！',
      },
    ],
  },
  faq: {
    title: '常见问题',
    items: [
      {
        question: '吃瓜网站线路一是什么？',
        answer: '吃瓜网站线路一是一个专注于网红塌房、黑料爆料、娱乐八卦的实时资讯聚合平台。我们通过智能算法与人工编辑相结合的方式，为用户提供最新、最快、最全的吃瓜内容，覆盖51吃瓜网站入口、51吃瓜在线观看等热门通道。',
      },
      {
        question: '如何找到51吃瓜网站入口？',
        answer: '您可以直接访问我们的首页，在热门入口栏目中找到51吃瓜网站入口、51吃瓜在线观看、51吃瓜官网等热门通道。我们也提供了51吃瓜视频、吃瓜网址大全等辅助入口，方便您一站式获取所有吃瓜内容。',
      },
      {
        question: '网站上的爆料内容是否真实可靠？',
        answer: '我们建立了严格的内容审核机制，所有发布的爆料内容都经过多轮交叉验证。我们的内容真实率高达99.7%，是目前行业内可信度最高的吃瓜资讯平台之一。对于无法核实的内容，我们会明确标注"待核实"标签。',
      },
      {
        question: '如何匿名爆料？',
        answer: '我们非常重视爆料人的隐私保护。您可以通过网站底部的联系方式，使用加密邮箱或匿名社交账号向我们提供爆料线索。我们承诺对所有爆料人信息严格保密，绝不泄露给第三方。',
      },
      {
        question: '每日大赛栏目是什么？',
        answer: '每日大赛是我们最受欢迎的栏目之一，每天根据实时热度更新当天最火爆的吃瓜事件排行榜。您可以通过每日大赛快速了解当前最热门的网红塌房和黑料爆料，不错过任何一个大瓜。',
      },
      {
        question: '网站支持手机访问吗？',
        answer: '是的，吃瓜网站线路一采用了响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅的吃瓜体验。我们也在积极开发原生APP，敬请期待。',
      },
    ],
  },
};